/* ---------------------------------------------------------------------------------------------------------------------
   ET - PDP campaign pill (EcomTraffic)

   The sale pill on the main product image (snippets/product-gallery.liquid) belongs to the selected variant: it shows
   while that variant has a compare-at price above its price. The theme does not re-render the gallery on a variant
   change, so the pill is toggled here through its hidden attribute. Moving the badges row to the first visible slide
   stays with the gallery script in product-gallery.liquid.

   Listeners are delegated on the document, so a section reload in the theme editor needs no re-init.
--------------------------------------------------------------------------------------------------------------------- */

(function () {
  'use strict';

  var root = document.documentElement;
  if (root.hasAttribute('data-et-pdp-campaign')) return;
  root.setAttribute('data-et-pdp-campaign', '');

  function pillsForForm(formId) {
    var pills = [];
    if (!formId) return pills;

    document.querySelectorAll('product-gallery').forEach(function (gallery) {
      if (gallery.getAttribute('form') !== formId) return;
      gallery.querySelectorAll('[data-et-campaign-pill]').forEach(function (pill) {
        pills.push(pill);
      });
    });

    return pills;
  }

  /* data-et-sale-variants lists the on-sale variants as "id:percent"; null means the variant is not on sale. */
  function salePercent(pill, variantId) {
    var entries = (pill.getAttribute('data-et-sale-variants') || '').split(',');
    for (var i = 0; i < entries.length; i++) {
      var parts = entries[i].split(':');
      if (parts[0] === String(variantId)) return parts[1] || '';
    }
    return null;
  }

  function showPill(pill, percent) {
    pill.hidden = percent === null;
    if (percent === null) return;

    var label = pill.getAttribute('data-et-label');
    if (label) pill.textContent = label.split('[percent]').join(percent);
  }

  /* The theme dispatches variant:change on the product form with the full variant (prices in cents). A combination
     that does not exist comes through as an empty object, which hides the pill. */
  document.addEventListener('variant:change', function (event) {
    var form = event.target;
    var variant = event.detail && event.detail.variant;
    if (!variant || !form || typeof form.getAttribute !== 'function') return;

    pillsForForm(form.getAttribute('id')).forEach(function (pill) {
      var percent;

      if (typeof variant.price === 'number') {
        percent =
          typeof variant.compare_at_price === 'number' && variant.compare_at_price > variant.price
            ? String(Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price))
            : null;
      } else {
        percent = salePercent(pill, variant.id);
      }

      showPill(pill, percent);
    });
  });

  /* Fallback for scripts that only swap the variant id of the form (apps, bundles) without a variant:change event. */
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.name !== 'id' || !input.form) return;

    pillsForForm(input.form.getAttribute('id')).forEach(function (pill) {
      showPill(pill, salePercent(pill, input.value));
    });
  });
})();
